export class Controller {

    /** @ngInject */
    constructor($state, $uibModal, Alert, GroupsResource) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    $onInit() {
    }

    saveGroupName(groupName) {
        return this.GroupsResource
            .renameGroup(this.companyId, this.group.id, groupName)
            .then(() => this.$state.reload('company.user-directories'))
            .then(() => this.Alert('success', 'company.user-directories.manage-group.settings.renamed'));
    }

    showRemoveModal() {
        this.$uibModal
            .open({
                component: 'companyUserDirectoriesManageGroupRemove',
                resolve: {
                    companyId: () => this.companyId,
                    groupId: () => this.group.id,
                },
            }).result
            .then(() => this.$state.go('company.user-directories'))
            .then(() => {
                const key = 'company.user-directories.manage-group.remove.removed';
                const variables = {groupName: this.group.groupName};
                this.Alert('success', key, variables);
            })
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/settings/group-settings.controller.js